import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 110,
	viewBox: "0 0 110 110",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1522_55187)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z",
			fill: "url(#paint0_linear_1522_55187)"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M55 20.1667C35.7542 20.1667 20.1667 35.7542 20.1667 55C20.1667 74.2458 35.7542 89.8333 55 89.8333C74.2458 89.8333 89.8333 74.2458 89.8333 55C89.8333 35.7542 74.2458 20.1667 55 20.1667ZM16.5 55C16.5 33.7291 33.7291 16.5 55 16.5C76.2709 16.5 93.5 33.7291 93.5 55C93.5 76.2709 76.2709 93.5 55 93.5C33.7291 93.5 16.5 76.2709 16.5 55ZM55 38.5C56.0125 38.5 56.8333 39.3208 56.8333 40.3333V55C56.8333 56.0125 56.0125 56.8333 55 56.8333C53.9875 56.8333 53.1667 56.0125 53.1667 55V40.3333C53.1667 39.3208 53.9875 38.5 55 38.5ZM53.1667 69.6667C53.1667 68.6541 53.9875 67.8333 55 67.8333H55.0367C56.0492 67.8333 56.87 68.6541 56.87 69.6667C56.87 70.6792 56.0492 71.5 55.0367 71.5H55C53.9875 71.5 53.1667 70.6792 53.1667 69.6667Z",
			fill: "#FF4C57"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1522_55187",
		x1: 16.115,
		y1: 16.115,
		x2: 93.885,
		y2: 93.885,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#FFE8E9",
			stopOpacity: 0
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FFE8E9"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1522_55187",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 110,
			height: 110,
			fill: "white"
		})
	})] })]
});
export default SvgErrorIcon;
